import { Component, Host, h } from '@stencil/core';

const BoltIconSolid = () => (
  <svg
    class="bolt-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fill-rule="evenodd"
      d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z"
      clip-rule="evenodd"
    />
  </svg>
);

@Component({
  tag: 'webcomet-powered-by',
  styleUrl: 'powered-by.scss',
  shadow: true,
})
export class PoweredBy {
  render() {
    return (
      <Host>
        <div class="powered-by">
          <BoltIconSolid class="icon" />
          <a href="https://www.webcomet.io" target="_blank">
            Powered by webcomet FAQ
          </a>
        </div>
      </Host>
    );
  }
}
